import { useEffect } from 'react';

/**
 * Debounce route rebuilds when inputs change.
 */
export function useAutoBuild({
	autoBuildPending,
	setAutoBuildPending,
	loading,
	canBuild,
	handleBuildRoute,
	isIndoor,
}) {
	useEffect(() => {
		if (!autoBuildPending) return;
		if (loading) return;
		if (!canBuild) return;
		const timer = setTimeout(
			() => {
				(async () => {
					try {
						await handleBuildRoute();
					} finally {
						setAutoBuildPending(false);
					}
				})();
			},
			isIndoor ? 150 : 450
		);
		return () => clearTimeout(timer);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [autoBuildPending, canBuild, handleBuildRoute, loading, isIndoor]);

	useEffect(() => {
		if (autoBuildPending && !canBuild && !loading) {
			setAutoBuildPending(false);
		}
	}, [autoBuildPending, canBuild, loading, setAutoBuildPending]);
}
